import { render, staticRenderFns } from "./mob-full.vue?vue&type=template&id=798e6e6f&scoped=true"
import script from "./mob-full.vue?vue&type=script&setup=true&lang=js"
export * from "./mob-full.vue?vue&type=script&setup=true&lang=js"
import style0 from "./mob-full.vue?vue&type=style&index=0&id=798e6e6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e6e6f",
  null
  
)

export default component.exports